import React from 'react';
import InvoicesAdmin from '../admin/InvoicesAdmin';

const Invoices = () => {
  return <InvoicesAdmin />;
};

export default Invoices;
